import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { FiInstagram, FiPhone } from "react-icons/fi";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email");
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscribe`,
        { email }
      );

      alert(res.data.message);
      setEmail("");
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <footer className="bg-black text-gray-400 mt-16 text-sm">
      
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Brand */}
        <div>
          <h2 className="text-lg font-semibold text-white mb-3 tracking-wide">
         RITESH PURI
          </h2>
          <p className="leading-relaxed">
            Premium everyday clothing designed for comfort,
            quality, and modern style.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-medium text-white mb-4">
            Quick Links
          </h3>
          <ul className="space-y-2">
            {[
              { name: "Home", path: "/" },
              { name: "Shop", path: "/products" },
              { name: "New Arrivals", path: "/products?filter=new" },
              { name: "Contact", path: "/contact" },
            ].map((item, index) => (
              <li key={index}>
                <Link to={item.path} className="relative inline-block group">
                  <span className="group-hover:text-white transition duration-300">
                    {item.name}
                  </span>
                  <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-white transition-all duration-300 group-hover:w-full"></span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Support */}
        <div>
          <h3 className="font-medium text-white mb-4">
            Support
          </h3>
          <ul className="space-y-2">
            {[
              { name: "Size Guide", path: "/size-guide" },
              { name: "Return Policy", path: "/return-policy" },
              { name: "Privacy Policy", path: "/privacy-policy" },
              { name: "Terms & Conditions", path: "/terms" },
            ].map((item, index) => (
              <li key={index}>
                <Link to={item.path} className="relative inline-block group">
                  <span className="group-hover:text-white transition duration-300">
                    {item.name}
                  </span>
                  <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-white transition-all duration-300 group-hover:w-full"></span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="font-medium text-white mb-4">
            Stay Connected
          </h3>
          <p className="mb-4">
            Subscribe for new arrivals & exclusive offers.
          </p>

          <form onSubmit={handleSubscribe} className="flex">
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent border border-gray-600 px-3 py-2 w-full rounded-l focus:outline-none focus:border-white text-gray-300 placeholder-gray-500"
            />
            <button
              type="submit"
              className="bg-white text-black px-4 rounded-r hover:bg-gray-200 transition"
            >
              Join
            </button>
          </form>

          {/* Social Icons */}
          <div className="flex space-x-5 mt-6">
            <a
              href="https://www.instagram.com/realriteshpuri/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition duration-300"
            >
              <FiInstagram size={20} />
            </a>

            <a
              href="https://wa.me/919834704067"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition duration-300"
            >
              <FiPhone size={20} />
            </a>
          </div>

        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-800 py-4 text-center text-xs text-white-500">
        © {new Date().getFullYear()} Made with ❤️ by Gayatri Puri
      
      </div>
    </footer>
  );
};

export default Footer;